import { PrQueryRequest } from '../types';

export function getReviewsQuery({
  user, from, to, org,
}: PrQueryRequest) {
  return `commenter:${user} -author:${user} org:${org} is:pr sort:updated updated:${from.format(
    'YYYY-MM-DD'
  )}..${to.format('YYYY-MM-DD')}`;
}
